import React from "react";
import { useNavigate } from "react-router-dom";

const CTAs = ({
  type,
  text,
  icon,
  width = "auto",
  borderColor,
  position,
  onClick,
  overlay,
  disabled = false,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (type === "Disabledbtn" || disabled) return;
    if (onClick) {
      onClick();
    } else if (!overlay) {
      switch (type) {
        case "Primarybtn":
        case "Gradientbtn":
        case "Signinbtn":
          navigate("/");
          break;
        default:
          navigate("/");
      }
    }
  };

  const getButtonClass = () => {
    switch (type) {
      case "Primarybtn":
        return "dd-btn-primary";
      case "Secondarybtn":
        return "dd-btn-secondary";
      case "Deletebtn":
        return "dd-btn-danger";
      case "Disabledbtn":
        return "dd-btn-primary"; // will be disabled via attribute
      case "Signinbtn":
        return "dd-btn-primary gradient";
      default:
        return "dd-btn-secondary";
    }
  };

  return (
    <>
      <style>{`
        .dd-btn-secondary {
          display: inline-flex; align-items: center; justify-content: center; gap: 6px;
          padding: 8px 18px;
          background: #ffffff; border: 1px solid #E2E8F0; border-radius: 8px;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px; font-weight: 600; color: #0F172A;
          cursor: pointer; box-shadow: 0 1px 2px rgba(0,0,0,0.05);
          transition: border-color 0.15s, background 0.15s;
        }
        .dd-btn-secondary:hover { border-color: #94A3B8; background: #F8FAFC; }

        .dd-btn-primary {
          display: inline-flex; align-items: center; justify-content: center; gap: 6px;
          padding: 8px 18px;
          background: #2563EB; border: 1px solid #2563EB; border-radius: 8px;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px; font-weight: 600; color: #ffffff;
          cursor: pointer; transition: background 0.15s, box-shadow 0.15s;
        }
        .dd-btn-primary:hover { background: #1D4ED8; box-shadow: 0 4px 12px rgba(37,99,235,0.25); }
        .dd-btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }

        .dd-btn-danger {
          display: inline-flex; align-items: center; justify-content: center; gap: 6px;
          padding: 8px 18px;
          background: #EF4444; border: 1px solid #EF4444; border-radius: 8px;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px; font-weight: 600; color: #ffffff;
          cursor: pointer;
          transition: background 0.15s, box-shadow 0.15s;
        }
        .dd-btn-danger:hover { background: #DC2626; box-shadow: 0 4px 12px rgba(239,68,68,0.25); }

        .dd-btn-primary.gradient {
          background: linear-gradient(135deg, #1A1054 0%, #255FF1 100%);
          border: none;
        }
        .dd-btn-primary.gradient:disabled {
          opacity: 0.6; cursor: not-allowed;
        }
      `}</style>
      <button
        className={getButtonClass()}
        style={{ width: width === "w-auto" ? "auto" : width }}
        onClick={handleClick}
        disabled={disabled || type === "Disabledbtn"}
      >
        {icon && <span className="dd-btn-icon">{icon}</span>}
        {text}
      </button>
    </>
  );
};

export default CTAs;
